export default "__VITE_PUBLIC_ASSET__07b94e21__"